import React from "react";
import "../../Styles/yellowcalf.css/Wallet_Recharges.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

function Wallet_Recharges() {
  return (
    <div className="recharge-container " style={{ paddingTop: "25px" }}>  
      {/* Action Panel */}
      <div className="recharge-panel recharge-main-page-header">
        <div className="recharge-panel-body ">
          <div className="recharge-header">
            <h3 className="recharge-title">Wallet Recharges</h3>
            <div className="recharge-btn-group d-flex">
              <a
                className="recharge-btn recharge-btn-green"
                href="/accountant/New_Recharge"
              >
                New Recharge
              </a>

              <div className="recharge-dropdown">
                <button className="recharge-btn recharge-btn-warning dropdown-toggle" data-bs-toggle="dropdown">
                  Export <i className="fa fa-angle-down"></i>
                </button>
                <ul className="recharge-dropdown-menu dropdown-menu dropdown-menu-end">
                  <li><a href="#" className="recharge-export">Save as PDF</a></li>
                  <li><a href="#" className="recharge-export">Save as PNG</a></li>
                  <li><a href="#" className="recharge-export">Save as CSV</a></li>
                  <li><a href="#" className="recharge-export">Save as TXT</a></li>
                  <li><a href="#" className="recharge-export">Save as XML</a></li>
                  <li><a href="#" className="recharge-export">Save as SQL</a></li>
                  <li><a href="#" className="recharge-export">Save as JSON</a></li>
                  <li><a href="#" className="recharge-export">Export to Excel</a></li>
                  <li><a href="#" className="recharge-export">Export to Word</a></li>
                  <li><a href="#" className="recharge-export">Export to PowerPoint</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="recharge-panel">
        <div className="recharge-panel-body">
          <div className="recharge-table-responsive">
            <table className="recharge-table table  table-hover">
              <thead>
                <tr className="recharge-filters">
                  
                  <td><input placeholder="student name" type="text" className="form-control" /></td>
                  <td><input placeholder="date/time" type="text" className="form-control" /></td>
                  <td><input placeholder="recharge id"  type="text" className="form-control" /></td>
                  
                </tr>
                <tr>
                  <th>Sr.NO</th>
                  <th>Student</th>
                  <th>Amount</th>
                  <th>Date Time</th>
                  <th>Recharge ID</th>
                  <th>Reference No</th>
                  <th>Recharge Mode</th>
                  <th>Operator</th>
                  <th>Status</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>John Doe</td>
                  <td>₹500</td>
                  <td>2025-09-24 14:30</td>
                  <td>RCG12345</td>
                  <td>REF998877</td>
                  <td>Online</td>
                  <td>Paytm</td>
                  <td>Success</td>
                  <td></td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>John Doe</td>
                  <td>₹500</td>
                  <td>2025-09-24 14:30</td>
                  <td>RCG12346</td>
                  <td>REF998878</td>
                  <td>Online</td>
                  <td>Paytm</td>
                  <td>Success</td>
                  <td></td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>John Doe</td>
                  <td>₹500</td>
                  <td>2025-09-24 14:30</td>
                  <td>RCG12346</td>
                  <td>REF998878</td>
                  <td>Online</td>
                  <td>Paytm</td>
                  <td>Success</td>
                  <td></td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>John Doe</td>
                  <td>₹500</td>
                  <td>2025-09-24 14:30</td>
                  <td>RCG12346</td>
                  <td>REF998878</td>
                  <td>Online</td>
                  <td>Paytm</td>
                  <td>Success</td>
                  <td></td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>John Doe</td>
                  <td>₹500</td>
                  <td>2025-09-24 14:30</td>
                  <td>RCG12346</td>
                  <td>REF998878</td>
                  <td>Online</td>
                  <td>Paytm</td>
                  <td>Success</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <div className="wallet-main-footer">
              <ul className="wallet-main-pagination">
                <li className="wallet-main-active">
                  <a href="#">1</a>
                </li>
                <li>
                  <a href="#">2</a>
                </li>
                <li>
                  <a href="#">3</a>
                </li>
              </ul>

              <div className="wallet-main-summary">
                Showing <b>1-50</b> of <b>177</b> items.
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Wallet_Recharges;
